/**
 * district_id에서 city_id를 추출하는 함수
 *
 * 한국 행정구역 코드 체계:
 * - city_id: 시도 코드 (2자리) + 00000000 (8개의 0) = 10자리
 *   예: 1100000000 (서울), 4100000000 (경기)
 * - 세종 예외: 36으로 시작하면 앞 4자리 + 000000 = 10자리
 *   예: 3611000000 (세종)
 *
 * district_id 패턴:
 * - 4자리 패턴: 1162000000 (서울 강남구)
 * - 5자리 패턴: 1121500000 (서울 광진구)
 * - 7자리 패턴: 4111100000 (경기 수원시 장안구)
 *
 * @param districtId district ID (10자리)
 * @returns city ID (10자리)
 */
export const extractCityId = (districtId: string): string => {
  if (!districtId) {
    console.error('districtId is required');
    return '';
  }

  // Remove leading minus sign if present (for "전체" districts)
  const cleanDistrictId = districtId.startsWith('-') ? districtId.substring(1) : districtId;

  if (cleanDistrictId.length !== 10) {
    console.error('Invalid districtId format. Must be 10 digits:', districtId);
    return districtId;
  }

  // 세종 예외 처리: 36으로 시작하면 앞 4자리 + 000000
  if (cleanDistrictId.startsWith('36')) {
    const cityId = cleanDistrictId.substring(0, 4) + '000000';
    return cityId;
  }

  // 일반 케이스: 앞 2자리 (시도코드) + 00000000
  const cityId = cleanDistrictId.substring(0, 2) + '00000000';

  return cityId;
};
